<router-outlet></router-outlet>
<ngx-spinner></ngx-spinner>

<!-- <small>
  env: {{envService.env}}
</small> -->
